<template>
  <div class="vue iw-basic iw-party-collection iw-party-collection-generic">

    <LoaderOverlay v-if="loading" :image="loader"/>
    <div
      class="tp-featured iw-container"
      :class="{ 'shorter-padding': contestData.pinCanBeRequested, 'legal-notes-padding': contestData.legalNotes !== '' }"
    >

      <!-- HEADER / BEGIN -->
      <div class="iw-header">
        <div class="row row-eq-height">
          <div class="col-md-6  text-right">
            <div class="iw-info half-container-md text-left p-4">

              <!-- STATE : OPEN / BEGIN -->
              <div v-if="current_state == 'open' || !current_state">
                <h1 class="tp-title iw-title text-white" v-html="current_contest.title"></h1>
                <div class="tp-description iw-description text-white d-none d-md-block mt-4"
                     v-html="current_contest.description"></div>

                <!--<div v-if="contestData.finalExtractionDate" class="mt-4 text-yellow">{{ __('L\'estrazione finale avverrà entro il ') }} <span class="font-weight-bold">{{ formatTimestamp(contestData.finalExtractionDate) }}</span></div>-->

                <div v-if="legal_notes" class="legal-notice mt-4">
                  <div v-html="legal_notes"></div>
                </div>

                <!--<div v-if="contestData.regulationUrl" class="small mt-4">Scarica qui il <a :href="contestData.regulationUrl" target="_blank" class="text-white font-weight-bold">Regolamento</a></div>-->

                <div class="mt-3 timparty-badge-counter">
                  <!-- <small><img :src="modulePath('/js/src/assets/images/icon-2x-teal.png')" class="mr-2"> Raddoppia le tue chance di vincita con TIM UNICA</small>-->
                  <span class="bg-accent small text-dark p-1">CON LA DOMICILIAZIONE DELLA FATTURA O TIM RICARICA AUTOMATICA HAI SUBITO 5 BADGE</span>
                  <br>
                  <span class="badge-counter-content">E CON <strong>TIM UNICA</strong> I BADGE DIVENTANO 10</span>
                </div>

                <badge-counter v-if="userBadgesCount !== null" label-text="HAI A DISPOSIZIONE"
                               :badge-count="userBadgesCount" :hide-info="false" class="big mt-4"></badge-counter>

                <div class="mt-3">
                  <span data-scroll-link="1"><u>Scopri di più</u></span>
                </div>
              </div>
              <!-- STATE : OPEN / END -->


              <!-- STATE : PLAYED / BEGIN -->
              <div v-if="current_state == 'played'">
                <h1 class="tp-title iw-title text-white" v-html="current_contest.title"></h1>
                <div class="tp-description iw-description text-white d-none d-md-block mt-4">
                  <p>Continua ad accumulare badge per Party Collection. Più badge hai al momento dell’estrazione, più
                    possibilità hai di vincere</p>

                </div>

                <div v-if="contestData.finalExtractionDate" class="mt-4">{{
                    __('L\'estrazione finale avverrà entro il ')
                  }} <span class="font-weight-bold text-yellow">{{
                      formatTimestamp(contestData.finalExtractionDate)
                    }}</span></div>

                <!--<div v-if="contestData.regulationUrl" class="small mt-4">Scarica qui il <a :href="contestData.regulationUrl" target="_blank" class="text-white font-weight-bold">Regolamento</a></div>-->
                <div class="mt-3 timparty-badge-counter">
                  <!-- <small><img :src="modulePath('/js/src/assets/images/icon-2x-teal.png')" class="mr-2"> Raddoppia le tue chance di vincita con TIM UNICA</small>-->
                  <span class="bg-accent small text-dark p-1">CON LA DOMICILIAZIONE DELLA FATTURA O TIM RICARICA AUTOMATICA HAI SUBITO 5 BADGE</span>
                  <br>
                  <span class="badge-counter-content">E CON <strong>TIM UNICA</strong> I BADGE DIVENTANO 10</span>
                </div>

                <badge-counter v-if="userBadgesCount !== null" label-text="STAI PARTECIPANDO CON"
                               :badge-count="userBadgesCount" :hide-info="false" class="big mt-4"></badge-counter>

                <div class="mt-3">
                  <span data-scroll-link="1"><u>Scopri di più</u></span>
                </div>
              </div>
              <!-- STATE : PLAYED / END -->


              <!-- STATE : CONTEST WAITING FOR EXTRACTION / BEGIN -->
              <div v-else-if="current_state == 'waiting_for_extraction' ">
                <h1 class="tp-title iw-title text-white" v-html="current_contest.title"></h1>
                <div class="tp-description iw-description text-white d-none d-md-block mt-4">

                  <h5 class="text-red font-weight-bold mt-5">{{ __('il concorso è terminato') }}</h5>

                  <p class="mt-4">
                    <span v-if="contestData.finalExtractionDate">L'estrazione finale avverrà entro il <span
                      class="font-weight-bold text-yellow">{{ formatTimestamp(contestData.finalExtractionDate) }}</span></span><br>
                  </p>

                </div>


              </div>
              <!-- STATE : CONTEST WAITING FOR EXTRACTION / END -->


              <!-- STATE : CONTEST ENDED / BEGIN -->
              <div v-else-if="current_state == 'ended' ">
                <h1 class="tp-title iw-title text-white" v-html="current_contest.title"></h1>
                <div class="tp-description iw-description text-white d-none d-md-block mt-4">

                  <h5 class="text-red font-weight-bold mt-5">{{ __('il concorso è terminato') }}</h5>

                  <p class="mt-4">
                    <span v-if="contestData.finalExtractionDate">L'estrazione finale è avvenuta il <span
                      class="text-yellow font-weight-bold">{{ formatTimestamp(contestData.finalExtractionDate) }}</span></span><br>
                    <strong>{{ __('Non hai vinto...') }}</strong>
                  </p>

                </div>

                <div class="mt-5">
                  <a href="#" @click="showWinners"
                     class="font-weight-bold btn text-primary btn-secondary">{{ __('SCOPRI TUTTI I VINCITORI') }} &nbsp;&gt;</a>
                </div>
              </div>
              <!-- STATE : CONTEST ENDED / END -->

              <!-- STATE : WON / BEGIN -->
              <div v-else-if="current_state == 'won' ">
                <h1 class="tp-title iw-title text-white">
                  {{ __('Hai vinto questo concorso') }}&nbsp;<a href="#" @click.prevent="showShareModal"><img
                  :src="modulePath('/js/src/assets/images/icon-white-share.png')" class="img-fluid ml-3"></a>
                </h1>
              </div>
              <!-- STATE : WON / BEGIN -->


            </div>
          </div>
          <div class="col-md-6 iw-carousel-container p-0">

            <!-- FEATURED CAROUSEL - BEGIN -->
            <featured-carousel :images='sliderImages'></featured-carousel>
            <!-- FEATURED CAROUSEL - END -->

          </div>
        </div>
      </div>
      <!-- HEADER / END -->


      <!-- ------------------------------------ -->


      <!-- ACTIONS / BEGIN  -->

      <div class="iw-actions-bar-container" v-if="current_state">
        <div class="container p-0">
          <div class="iw-actions-bar">


            <!-- STATE : OPEN / BEGIN -->
            <div v-if="current_state == 'open'">

              <div class="row no-gutters">

                <div class="col-md-6 d-flex align-items-center justify-content-left p-3" v-if="contestData.endDate">
                  <countdown v-if="countdown.time" class="iw-countdown" :ts-end="countdown.time"
                             :heading="countdown.label"></countdown>
                </div>
                <div class="col-md-3 p-3">
                  <div v-if="userBadgesCount !== null">
                    <div v-if="threshold_reached">
                      <strong>{{ __('Clicca "Partecipa" e accetta il regolamento') }}</strong><br>
                      {{ __('Prova a vincere il super premio Party Collection') }}
                    </div>
                    <div v-else>

                      <strong class="text-red">{{ __('Ti mancano') }} {{ contestData.badgeRequired - userBadgesCount }}
                        {{ __(' badge per giocare') }}</strong><br>
                      {{ __('Partecipa ai nostri concorsi e iniziative per accumulare più badge.') }}
                    </div>
                  </div>
                </div>
                <div class="col-md-3 d-flex align-items-top">
                  <div class="w-100">
                    <div class="iw-play-container">
                      <button :disabled="!threshold_reached" class="btn btn-primary btn-lg btn-block iw-btn-play"
                              @click.prevent="showAcceptanceModal">
                        {{ current_contest.buttonLabel ? current_contest.buttonLabel : __('Gioca') }}
                      </button>
                      <!--<div class="iw-btn-play-tooltip d-flex justify-content-center align-items-center" v-if="current_contest.attemptsLeft"><span>{{ __('Hai ') }} <strong> {{ current_contest.attemptsLeft + __( current_contest.attemptsLeft > 1 ? ' giocate' : ' giocata') }} </strong> {{ __(' per tentare la fortuna.') }}</span></div>-->
                    </div>
                  </div>
                </div>
              </div>

              <div class="tp-description iw-description text-white  d-block d-md-none py-4 px-3"
                   v-html="current_contest.description"></div>

            </div>
            <!-- STATE : OPEN END -->


            <!-- STATE : PLAYED / BEGIN -->
            <div v-if="current_state == 'played'">

              <div class="row no-gutters">

                <div class="col-md-6 d-flex align-items-center justify-content-left p-3" v-if="contestData.endDate">
                  <countdown class="iw-countdown" :ts-end="contestData.endDate"
                             :heading="__('MANCANO SOLO')"></countdown>
                </div>
                <div class="col-md-3 p-3">
                  <strong>{{ __('Stai già partecipando all’estrazione finale') }}</strong><br>
                  {{
                    __('Per accumulare più badge e aumentare le possibilità di vincita partecipa agli altri concorsi di TIM Party.')
                  }}


                </div>
                <div class="col-md-3 d-flex align-items-top">
                  <div class="w-100">
                    <div class="iw-play-container">
                      <a class="btn btn-primary btn-lg btn-block iw-btn-play  cta-generic"
                         href="/gioca-e-vinci">{{ __('VAI AI CONCORSI') }}</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tp-description iw-description text-white  d-block d-md-none py-4 px-3"
                   v-html="current_contest.description"></div>

            </div>
            <!-- STATE : PLAYED / END -->


            <!-- STATE : WAITING FOR EXTRACTION / BEGIN -->
            <div v-if="current_state == 'waiting_for_extraction'">
              <div class="d-block d-md-none p-3 mb-5">

                <h5 class="text-red font-weight-bold mt-5">{{ __('il concorso è terminato') }}</h5>

                <p class="mt-4">
                  <span v-if="contestData.finalExtractionDate">L'estrazione finale avverrà entro il <span
                    class=" font-weight-bold text-yellow">{{ formatTimestamp(contestData.finalExtractionDate) }}</span></span><br>
                </p>
              </div>

              <div class="row">
                <div class="col-md-8">
                  <div class="d-flex align-items-center">
                    <div class="p-3">
                      <h5 class="font-weight-bold text-red">{{
                          __('Se hai partecipato al Concorso, torna presto per scoprire il nome del vincitore.')
                        }}</h5>
                      <p>{{
                          __('Il vincitore sarà contattato direttamente dal nostro Servizio Clienti, non appena verrà effettuata l’estrazione finale.')
                        }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 d-flex align-items-center justify-content-end">
                  <div class="p-3 w-100">
                    <a href="/gioca-e-vinci"
                       class="btn btn-action btn-lg btn-block cta-generic">{{ __('Scopri altri concorsi') }}</a>
                  </div>
                </div>

              </div>

            </div>
            <!-- STATE : WAITING FOR EXTRACTION / END -->


            <!-- STATE : CONTEST ENDED / BEGIN -->
            <div v-else-if="current_state == 'ended'" class="">
              <div class="d-block d-md-none p-3 mb-5">

                <h5 class="text-red font-weight-bold mt-5">{{ __('il concorso è terminato') }}</h5>

                <p class="mt-4">
                  <span v-if="contestData.finalExtractionDate">L'estrazione finale è avvenuta il <span
                    class="text-yellow font-weight-bold">{{
                      formatTimestamp(contestData.finalExtractionDate)
                    }}</span></span><br>
                  <strong>{{ __('Non hai vinto...') }}</strong>
                </p>

                <div class="mt-5">
                  <a href="#" @click="showWinners"
                     class="font-weight-bold btn text-primary btn-secondary">{{ __('SCOPRI TUTTI I VINCITORI') }} &nbsp;&gt;</a>
                </div>

              </div>


              <div class="row">
                <div class="col-md-6">
                  <div class="d-flex align-items-center">
                    <div class="p-3" v-if="!is_ended">
                      <h5 class="font-weight-bold text-red">{{ __('Tenta la fortuna con i nuovi concorsi') }}</h5>
                      <p>Abbiamo pronti per te <u><a href="/gioca-e-vinci">nuovi concorsi</a></u>. Prova subito a
                        vincere!</p>
                    </div>
                    <div class="p-3" v-else>
                      <h5 class="font-weight-bold text-red">{{ __('Purtroppo, questa volta non hai vinto.') }}</h5>
                      <p>{{
                          __('Non mollare: continua a accumulare badge e fatti trovare pronto per il prossimo Party Collection!')
                        }}</p>
                    </div>
                  </div>
                </div>
                <!--
                <div class="col-md-4 offset-md-2 d-flex align-items-center justify-content-end">
                  <div class="p-3 w-100">
                    <a href="/gioca-e-vinci" class="btn btn-action btn-lg btn-block cta-generic" >{{ __('Scopri altri concorsi') }}</a>
                  </div>
                </div>
                -->
              </div>

            </div>
            <!-- STATE : CONTEST ENDED  / END -->


            <!-- STATE : WON / BEGIN -->
            <div v-else-if="current_state == 'won'" class="">


              <div class="row no-gutters">
                <div class="col-md-6 p-3">
                  <div class="d-flex align-items-center rewards-summary">

                    <div class="pr-3 " v-if="play_data_rewards_name">
                      <img :src="modulePath('/js/src/assets/images/icon-teal-gift-open.png')" class="reward-gift-icon">
                    </div>
                    <div class="pr-3" v-if="play_data_rewards_name">
                      <div class="reward-label">{{ __('Hai vinto') }}</div>
                      <div class="reward-name" v-html="play_data_rewards_name"></div>
                    </div>

                    <div class="pr-3" v-if="play_data_rewards_name && !pre_release && play_data.badgeAcquired">
                      <img :src="modulePath('/js/src/assets/images/icon-teal-plus.png')" class="reward-plus-icon">
                    </div>
                    <div class="pr-3" v-if="!pre_release && play_data.badgeAcquired">
                      <img :src="modulePath('/js/src/assets/images/icon-teal-badge.png')" class="reward-badge-icon"/>
                    </div>
                    <div class="pr-3" v-if="!pre_release && play_data.badgeAcquired">
                      <div class="reward-label">{{ __('Hai ottenuto') }}</div>
                      <div class="reward-name"> {{ play_data.badgeAcquired }} {{ __('badge') }}</div>
                    </div>
                  </div>

                </div>
                <div class="col-md-3 d-flex align-items-center justify-content-center p-3" v-if="contestData.endDate">
                  <div>{{ __('Non hai ricevuto il premio? Contatta l’assistenza.') }}</div>
                </div>
                <div class="col-md-3 d-flex align-items-top">
                  <div class="w-100 p-3">
                    <a v-if="!pre_release" class="btn btn-primary btn-lg btn-block"
                       href="/come-contattarci">{{ __('Contattaci') }}</a>
                  </div>
                </div>
              </div>

            </div>
            <!-- STATE : WON  / END -->


          </div>
        </div>
      </div>
    </div>
    <!--      <div v-if="contestData.legalNotes !== ''" class="legal-notes">-->
    <!--        <div class="container pb-5 pt-2 small">-->
    <!--          {{ contestData.legalNotes }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!-- ACTIONS / END  -->


    <div class="bg-warning p-4" v-if="environment == 'dev'">
      <div class="container">
        <h5>Development tools</h5>

        <div class="form-inline my-2">
          <select v-model="current_state" class="form-control form-control-md">
            <option value="">---</option>
            <option value="open">open</option>
            <option value="played">played</option>
            <option value="waiting_for_extraction">waiting_for_extraction</option>
            <option value="ended">ended</option>
            <option value="won">won</option>
          </select>


          <div class="form-group ml-4">
            <div class="form-checkbox">
              <input class="form-checkbox-input" type="checkbox" v-model="allow_play">
              <label class="form-checkbox-label">Allow play</label>
            </div>
          </div>

        </div>
      </div>

    </div>


    <!-- MODAL ACCEPTANCE / START -->
    <!--        <basic-modal :modal-id="modal.id" modal-class="modal-md" class="modal-acceptance" :show="modal.show" v-on:modalClose="modal.show = false">-->
    <basic-modal :modal-id="modal_id" modal-class="modal-md" class="modal-acceptance" :show="modal.show"
                 v-on:modalClose="modal.show = false">
      <div v-if="!modal.error">


        <!-- STATE ACCEPTANCE - BEGIN -->
        <div v-if="modal.state == 'acceptance'">
          <div class="modal-body">
            <h4>Prova a vincere il super premio Party Collection.<br/>Per partecipare inserisci la tua e-mail, accetta
              il Regolamento del concorso e prendi visione dell’Informativa Privacy.</h4>

            <div class="form-timparty">
              <div :class="'form-group mt-4 mb-0 ' + ( is_valid_email ? '' : 'has-error')">
                <label>{{ __('Email di partecipazione') }}</label>
                <input type="text" class="form-control" v-model="user_email">
              </div>
            </div>

            <!--  REGULATION ACCEPTANCE / START -->
            <div v-if="contestData.regulationInfo != undefined && contestData.regulationInfo != ''" class="mb-4">

              <label for="contest-regulation">{{ __('Regolamento') }}</label>
              <div class="textarea-acceptance" id="contest-regulation" v-html="contestData.regulationInfo"></div>

              <div class="custom-control custom-checkbox mt-3">
                <input type="checkbox" class="custom-control-input" id="regulation-acceptance"
                       v-model="acceptances.regulation">
                <label class="custom-control-label" for="regulation-acceptance">{{
                    __('Accetto il regolamento')
                  }}</label>
              </div>
            </div>
            <div v-else-if="contestData.regulationUrl != undefined && contestData.regulationUrl != ''">

              <div class="custom-control custom-checkbox mt-3">
                <input type="checkbox" class="custom-control-input" id="regulation-acceptance"
                       v-model="acceptances.regulation">
                <label class="custom-control-label" for="regulation-acceptance">{{ __('Accetto il ') }} <a
                  :href="contestData.regulationUrl" target="_blank">{{ __('Regolamento ') }}</a></label>
              </div>
            </div>
            <!--  REGULATION ACCEPTANCE / END -->


            <!--  PRIVACY ACCEPTANCE / START -->
            <div v-if="contestData.privacyInfo != undefined && contestData.privacyInfo != ''" class="mb-4">

              <!--
              <h3 for="contest-privacy">{{ __('Informativa Privacy') }}</h3>
              <div class="textarea-acceptance"  id="contest-privacy" v-html="contestData.privacyInfo"></div>
              -->

              <div class="custom-control custom-checkbox mt-4">
                <input type="checkbox" class="custom-control-input" id="privacy-acceptance"
                       v-model="acceptances.privacy">
                <label class="custom-control-label"
                       for="privacy-acceptance">{{ __('Ho preso visione dell\'informativa privacy') }}</label><a
                v-if="contestData.privacyInfo" :href="contestData.privacyInfo" target="__blank"
                class="icon-badge-info ml-1"><img :src="modulePath('js/src/assets/images/icon-black-info-square.png')"></a>
              </div>
            </div>
            <!--  PRIVACY ACCEPTANCE / END -->
          </div>
          <div class="modal-footer bg-primary  p-4">
            <button class="btn btn-light btn-lg text-uppercase" @click="play" :disabled="!user_can_play">
              {{ __('Gioca Ora!') }}
            </button>
          </div>
        </div>
        <!-- STATE ACCEPTANCE - END -->

        <!-- STATE PLAY_RESULT - BEGIN -->
        <div v-else-if="modal.state == 'play_result'">
          <div class="modal-body text-center p-5">

            <img :src="modulePath('js/src/assets/images/icon-teal-check-big.png')" class="img-fluid">

            <h4>{{ __('Sei pronto a vincere?') }}</h4>

            <div>
              <p>Ora partecipi alla Party Collection e gareggi per l'estrazione del super premio finale. <strong>Più
                badge ottieni, più aumentano le tue possibilità di essere estratto</strong>.
                Per accumulare altri badge, ti basta partecipare ai nostri concorsi.</p>
              <p>Attivati ora!</p>
            </div>

            <badge-counter label-text="HAI A DISPOSIZIONE" class="mt-4" :alt-mode-image-prop="true"
                           :hide-info="false"></badge-counter>

            <div class="mt-5">
              <button class="btn btn-lg btn-outline-primary text-uppercase mx-2" @click="modal.show = false">
                {{ __('Chiudi') }}
              </button>
              <a href="/gioca-e-vinci" class="btn btn-primary btn-lg mx-2 cta-generic">{{ __('Vai ai concorsi') }}</a>
            </div>

          </div>
        </div>
        <!-- STATE PLAY_RESULT - END -->

        <!-- STATE SHARE - BEGIN -->
        <div v-else-if="modal.state == 'share'">
          <div class="modal-body text-center p-5">
            <h4>{{ __('Condividi') }}</h4>

            <div class="modal-share-buttons">
              <div class="row mt-5">
                <div class="col-4">
                  <div class="bg-primary-light p-3">
                    <img :src="modulePath('/js/src/assets/images/icon-white-whatsapp.png')" class="img-fluid ">

                    <div class="text-white mt-2">Whatsapp</div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="bg-primary-light p-3">
                    <img :src="modulePath('/js/src/assets/images/icon-white-facebook.png')" class="img-fluid ">
                    <div class="text-white mt-2">Facebook</div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="bg-primary-light p-3">
                    <img :src="modulePath('/js/src/assets/images/icon-white-twitter.png')" class="img-fluid ">
                    <div class="text-white mt-2">Twitter</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- STATE SHARE - END -->

        <div v-else-if="modal.state == 'winners'">
          <div class="modal-body text-center p-5">

            <div v-if="winners.length > 0">
              <h4>{{ __('Ecco i vincitori del concorso') }}</h4>
              <list-winners :winners="winners"></list-winners>
            </div>
            <div v-else>
              <p>Nessun vincitore trovato</p>
            </div>

            <button @click.prevent="modal.show = false" class="btn btn-primary btn-lg">{{ __('CHIUDI') }}</button>

          </div>
        </div>

      </div>
    </basic-modal>
    <!-- MODAL ACCEPTANCE / END -->


    <!-- MODAL ERROR / BEGIN -->
    <ErrorModal :error="error" v-on:modalClose="error = null"/>
    <!-- MODAL ERROR / END -->

  </div>
</template>

<script>

/* eslint-disable */

import moment       from "moment/moment";
import {mapGetters} from 'vuex'

import _ from 'lodash';
import $ from 'jquery';


import TimPartyMixin        from '../mixins/TimPartyMixin';
import TimPartyContestMixin from '../mixins/TimPartyContestMixin';

import BasicModal       from './BasicModal.vue'
import ErrorModal       from './ErrorModal.vue'
import Countdown        from './Countdown.vue'
import LoaderOverlay    from './LoaderOverlay.vue'
import FeaturedCarousel from './FeaturedCarousel.vue'
import BadgeCounter     from './BadgeCounter.vue'
import ListWinners      from './ListWinners.vue'

export default {
  name: 'InstantWinPartyCollectionGeneric',
  mixins: [TimPartyMixin, TimPartyContestMixin],
  components: {
    Countdown,
    LoaderOverlay,
    BasicModal,
    ErrorModal,
    FeaturedCarousel,
    BadgeCounter,
    ListWinners
  },
  props: {
    accessToken: String,
    apiUrl: String,
    userId: String,
    contestData: Object,
    loader: String,
    endDate: {
      type: String,
      default: '20230108235959'
    }

  },
  data: function () {

    return {
      loading: false,
      current_state: null,

      current_contest: {
        title: 'Concorso non disponibile',
        label: 'Gioca',
        label_get_reward: 'Riscuoti la tua vincita',
        message_loss: 'Siamo spiacenti, questa volta non hai vinto. Ritenta la prossima volta!'
      },
      next_contest_index: 0,
      attempts_left: 0,
      attempts_done: 0,

      play_data: {},

      modal: {
        id: 'modal-iw-basic',
        show: false,
        class_name: 'modal-lg',
        error: null,
        state: null
      },


      acceptances: {
        regulation: false,
        privacy: false
      },

      user_email: '',
      allow_play: false,

      is_ended: false
    };
  },
  mounted: function () {
    var self = this;

    this.setApiUrl(this.apiUrl);


    if (this.contestData != undefined) {


      if (this.contestData.extra.status != undefined) {
        this.current_state = this.contestData.extra.status;
      }


      if (this.contestData.play_result != undefined) {
        this.play_data = this.contestData.play_result;
      }

      if ($('body').find('[data-scroll-link]').length) {
        self.activateAnchorLinks();
      }


      this.gotoNextContest();
    }
    else {
      // TODO: load contest_data using API
    }

    this.user_email = this.user.email;

  },

  methods: {
    showAcceptanceModal: function () {

      // let contestType = null;
      // for (let contest of this.contestData.contests) {
      //   if (contest.hasDefaultRule) {
      //     contestType = contest.type;
      //     break;
      //   }
      // }

      if (this.current_contest.type === 'EXTERNAL') {
        window.location.href = this.contestData.externalUrl + '?access_token=' + this.accessToken;
      }
      else if (this.attempts_done > 0 || this.contestData.numUserPlayed > 0) {
        this.play();
      }
      else {
        this.modal.show  = true;
        this.modal.state = 'acceptance';
      }


    },

    activateAnchorLinks: function () {
      $(document).on('click', '[data-scroll-link]', function (e) {
        e.preventDefault();
        var id = $(this).data('scroll-link');
        $('html, body').animate({
          scrollTop: $("[data-scroll-id='" + id + "']").first().offset().top - $('#page').find('nav.navbar').height()
        }, 500);
      });
    },

    showShareModal: function () {
      this.modal.show  = true;
      this.modal.state = 'share';
    },

    play: function () {

      $('body').removeClass('modal-open');

      var self = this;

      this.aaEvent('click', {
        form: {
          click: "Partecipa"
        }
      });

      var payload = {
        action: 'play',
        access_token: this.accessToken,
        contest_id: this.current_contest.id,
        play_data: {
          email: self.user_email,
          selections: [{
            id: 0,
            text: ''
          }]
        }
      };


      this.loading    = true;
      self.modal.show = false;
      this.callApi(payload, function (response) {
        self.loading = false;

        if (!response.success) {
          self.current_state = null;

          self.showError(response.data);
        }
        else if (response.data.win != undefined) {


          self.current_state = 'played';

          self.modal.state = 'play_result';
          self.modal.show  = true;


          self.play_data = response.data;

          var gtmSubject = ((self.current_contest.rewards != undefined) && (self.current_contest.rewards[0] != undefined)) ? self.current_contest.rewards[0].title : self.current_contest.title;

          self.gtmEvent({
            event: 'partyCollection',
            eventCategory: 'Party Collection',
            eventAction: 'Partecipazione',
            eventLabel: gtmSubject
          });

        }
        else {
          self.current_state = null;

          self.showError('Errore nella giocata');
        }

      });

    },

    isEnded: function () {
      let end_date = moment(this.endDate, 'YYYYMMDDHHmmss');
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop)
      });

      let today     = params.today ? moment(params.today, 'YYYYMMDDHHmmss') : moment();
      this.is_ended = today.isAfter(end_date);
    }
  },
  computed: {
    ...mapGetters([
      'userBadgesCount'
    ]),


    play_data_rewards_name: function () {
      if (this.play_data.rewards != undefined && this.play_data.rewards.length > 0) {
        return _.map(this.play_data.rewards, function (item) {
          return item.reward.name;
        }).join('<br>');
      }
      else {
        return null;
      }
    },


    sliderImages: function () {

      if (_.has(this.contestData, 'extra.images.slider')) {
        return this.contestData.extra.images.slider;
      }
      else if (_.has(this.contestData, 'extra.images.featured')) {
        return this.contestData.extra.images.featured;
      }
      else {
        return [];
      }

    },

    threshold_reached: function () {
      return (this.userBadgesCount >= this.contestData.badgeRequired) || this.allow_play;
    },

    user_can_play: function () {

      if (
        ((this.contestData.regulationInfo != undefined && this.contestData.regulationInfo != '') || (this.contestData.regulationUrl != undefined && this.contestData.regulationUrl != ''))
        && !this.acceptances.regulation

      ) {
        return false;
      }

      if (
        (this.contestData.privacyInfo != undefined && this.contestData.privacyInfo != '')
        && !this.acceptances.privacy
      ) {
        return false;
      }

      if (!this.is_valid_email) {
        return false;
      }

      return true;
    },

    is_valid_email: function () {
      return this.checkEmail(this.user_email);
    },

    /*
    countdown_label: function(){
      var label = null;
      var now = Math.floor(new Date().getTime() / 1000);

      if(this.contestData.startDate != undefined && now < this.contestData.startDate){
        label = this.__('MANCANO SOLO');
      }
      else if(this.contestData.endDate != undefined && now < this.contestData.endDate){
        label = this.__('SCADE TRA');
      }

      return label;
    },

    countdown_time: function(){

      var time = null;
      var now = Math.floor(new Date().getTime() / 1000);

      if(this.contestData.startDate != undefined && now < this.contestData.startDate){
        time = this.contestData.startDate;
      }
      else if(this.contestData.endDate != undefined && now < this.contestData.endDate){
        time = this.contestData.endDate;
      }

      return time;

    },
    */

    countdown: function () {

      var now = Math.floor(new Date().getTime() / 1000);

      var result = {
        label: '',
        time: null
      };

      if (this.contestData) {

        if (this.contestData.startDate != undefined && now < this.contestData.startDate) {
          result.label = this.__('MANCANO SOLO');
          result.time  = this.contestData.startDate;
        }
        else if (this.contestData.endDate != undefined && now < this.contestData.endDate) {
          result.label = this.__('SCADE TRA');
          result.time  = this.contestData.endDate;
        }
      }

      return result;

    }
  },
  watch: {
    user: function (new_val, old_val) {
      if (new_val.email) {
        this.user_email = new_val.email;
      }
    },
    modal: function () {
      console.log('this.modal', this.modal);
    }
  }
}
</script>


